import {
  ApiEpPageconfig,
  apiRecursive,
  IApiEpPageconfig,
  IApiEpPageconfigListReq,
} from "@smp/api";
import { useQuery, UseQueryOptions } from "react-query";

const KEY_RECURSIVE = "recursive__ep.pageconfig";

export const useEpPageconfigListRecursive = (options?: {
  req?: IApiEpPageconfigListReq;
  useQueryOptions?: Omit<
    UseQueryOptions<IApiEpPageconfig[]>,
    "queryKey" | "queryFn"
  >;
}) => {
  const { data: pageconfigList, isLoading: isPageconfigListLoading } = useQuery(
    [KEY_RECURSIVE, options?.req],
    () => apiRecursive(ApiEpPageconfig.list, [options?.req]),
    options?.useQueryOptions,
  );

  return { isPageconfigListLoading, pageconfigList };
};

useEpPageconfigListRecursive.KEY = KEY_RECURSIVE;
